import { render } from "./entry-instructions.vue?vue&type=template&id=9c5fe58e"
import script from "./entry-instructions.vue?vue&type=script&lang=js"
export * from "./entry-instructions.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__